import generateRender from '../../../utils/generateRender';
import { BUTTON_STROKES } from '../../../utils/buttonTextStrokes';
export var messagePinkButtonStroke = generateRender({
  default: BUTTON_STROKES.GREEN
});
export var messageOrangeButtonStroke = generateRender({
  default: BUTTON_STROKES.TERTIARY,
  hri: BUTTON_STROKES.PURPLE
});